<template>
  <div style="display: none" />
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import appEnv from '@/support/env'

declare global {
  interface Window {
    _asgTracker: {
      visitorId: string
      decorateLinksInside: (el: HTMLElement) => void
      storeVisit: (params: Record<string, any>) => void
      utms: Record<string, string>
    }
  }
}

export default defineComponent({
  name: 'TrackingPixel',
  setup() {
    const scriptId = 'asg-tr'
    onMounted(() => {
      if (!appEnv.TRACKER_SCRIPT) {
        return
      }

      if (document.getElementById(scriptId) === null) {
        const script = document.createElement('script')
        script.setAttribute('id', scriptId)
        script.setAttribute('src', appEnv.TRACKER_SCRIPT)
        if (appEnv.TRACKER_DOMAIN) {
          script.dataset.trackingDomain = appEnv.TRACKER_DOMAIN
        }
        document.head.appendChild(script)
      }

      setTimeout(() => {
        if (window._asgTracker) {
          window._asgTracker.storeVisit({})
        }
      }, 500)
    })
  }
})
</script>
